import clsx from 'clsx';
import React from 'react';

import { Heading } from '@/components/typography/heading';

import styles from '../../contractDetails.module.scss';
import { ServerInfo } from './ServerInfo';

interface ServerData {
  type?: string;
  host?: string;
  schema?: string;
  database?: string;
}

interface Servers {
  source?: ServerData;
  destination?: ServerData;
}

interface ServersSectionProps {
  servers?: Servers;
}

export function ServersSection( { servers }: ServersSectionProps ) {
  if ( !servers || ( !servers.source && !servers.destination ) ) {
    return null;
  }

  return (
    <div className={ clsx( 'layout__row', 'pad' ) }>
      <div className={ clsx( styles.card, styles.noBorderCard ) } data-testid='servers-card'>
        <div className={ styles.cardHeader }>
          <Heading as='h3' size='sm'>Servers</Heading>
        </div>
        <div className={ styles.cardBody }>
          { servers.source && (
            <ServerInfo title="Source" server={ servers.source } />
          ) }

          { servers.source && servers.destination && (
            <div className={ styles.dividerLine } />
          ) }

          { servers.destination && (
            <ServerInfo title="Destination" server={ servers.destination } />
          ) }
        </div>
      </div>
    </div>
  );
}
